import { render, staticRenderFns } from "./naturalace.vue?vue&type=template&id=68b3e16e&scoped=true"
import script from "./naturalace.vue?vue&type=script&lang=js"
export * from "./naturalace.vue?vue&type=script&lang=js"
import style0 from "./naturalace.vue?vue&type=style&index=0&id=68b3e16e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b3e16e",
  null
  
)

export default component.exports